export const messages = {
  'zh-CN': {
    i18n: {
      home: '首页',
      paper: '文献',
      about: '关于',
      allDBPS: '搜索',
      help: '帮助',
      analyze: '信息分析',
      login:'登录',
      register:'注册',
      dbpsDetail: '这里是提供搜索与分享DBPs的平台',
      recommend: '论文推荐',
      readMore: '更多',
      standard: '标准文件和DBPs相关综述',
      literature: '文献相关',
      meeting: '会议信息',
      search: '请输入关键词',
      friendLink: '友情链接',
      hello:'您好',
      userCenter:'个人中心',
      exit:'退出',
      include:'已收录',
      item1:'条',
      pageViews:'总访问量',
      item2:'次',
      // Foot
      address: '地址',
      phone: '电话',
      fax: '传真',
      email: '邮箱',
      slogan: '环境水污染物查询',
      detial:'详情信息',
      edit:'[ 编辑 ]',
      showBigImg:'查看大图',
      showSmallImg:'查看缩略图',
      goBack:'返回',
      countTips:'条数据',
      unfold:'展开',
      fold:'收起',
      password:'密码',
      remember:'记住密码',
      forget:'忘记密码',
      nickname:'昵称',
      confirmPassword:'确认密码',
      reset:'重置',
      welcome:'欢迎来到DBPs数据库',
      normalUser:'普通用户',
      aboutMe:'个人资料',
      commitRecord:'提交记录',
      message:'消息中心',
      safetyCenter:'安全中心',
      userId:'用户ID',
      name:'姓名',
      unit:'单位',
      identity:'身份',
      degree:'学位',
      researchDirection:'研究方向',
      save:'保存',
      addNew:'增加新的',
      editRecord:'我编辑的',
      oldPassword:'原始密码',
      newPassword:'新密码',
      submit:'提交',
      status:'状态',
      number:'序号',
      expend:'展开',
      handle:'操作',
      date:'日期',
      wid:'提交序号',
      editColumn:'编辑的字段',
      suggestiveValue:'建议值',
      replenish:'参考文献',
      revocation:'撤回',
      checked:'已审核',
      pending:'待审核',
      passed:'已通过',
      unapproved:'未通过',
      helpText:'如果您在使用过程中遇到困难，请联系我们哦~'
    }
  },
  'en-US': {
    i18n: {
      home: 'Home',
      paper: 'Paper',
      about: 'About',
      allDBPS: 'Search',
      help: 'Help',
      analyze: 'Analyze',
      login:'Login',
      register:'Register',
      dbpsDetail: 'There are search and share DBPs state',
      recommend: 'Recommend',
      readMore: 'More',
      standard: 'Standard And Review',
      literature: 'Literature of Disinfection Byproducts',
      meeting: 'Meeting information',
      search: 'Please enter keywords',
      friendLink: 'Friend Links',
      hello:'Hello',
      userCenter:'User Center',
      exit:'Log out',
      include:'Data',
      item1:'',
      pageViews:'Page Views',
      item2:'',
      // Foot
      address: 'Address',
      phone: 'Phone',
      fax: 'Fax',
      email: 'Email',
      slogan: 'Query for environmental water pollutants',
      
      detial:'Detials',
      edit:'[ Edit ]',
      showBigImg:'Enlarge',
      showSmallImg:'Shrink',
      goBack:'Go back',
      countTips:'data items are queried',
      unfold:'Unfold',
      fold:'Fold',
      password:'Password',
      remember:'Remember',
      forget:'Lost password',
      nickname:'Nickname',
      confirmPassword:'Confirm Password',
      reset:'Reset',
      welcome:'Welcome to the DBPS database.',
      normalUser:'Normal User',
      aboutMe:'About Me',
      commitRecord:'Commit Record',
      message:'Message',
      safetyCenter:'Safety Center',
      userId:'User ID',
      name:'Name',
      unit:'Unit',
      identity:'Identity',
      degree:'Degree',
      researchDirection:'Research Direction',
      save:'Save',
      addNew:'Add New Record',
      editRecord:'Edit Record',
      oldPassword:'Old Password',
      newPassword:'New Password',
      submit:'Submit',
      status:'Status',
      number:'Number',
      expend:'Expend',
      handle:'Handle',
      date:'Date',
      wid:'WID',
      editColumn:'Edit Column',
      suggestiveValue:'Suggestive Value',
      replenish:'Replenish',
      revocation:'Revocation',
      checked:'Checked',
      pending:'Pending',
      passed:'Passed',
      unapproved:'Unapproved',
      helpText:'If you encounter difficulties in the use of the process, please contact us ~'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/common/i18n.js